import * as swcHelpers from '@swc/helpers';
import { Util } from '@grandvisionhq/common';
import { placeholderImage } from '@grandvisionhq/utils';

const imageSizes = {
    M: 171,
    L: 192,
    XL: 272,
    MAX: 544
};
function createResponsiveImage(image, alt, params) {
    const imageUrl = typeof image === 'string' ? image : image.url;
    const resolvedAlt = (typeof image === 'string' ? alt : image.alt) || alt;
    const settings = swcHelpers.objectSpread({
        fit: 'fill',
        format: 'jpeg',
        aspectRatio: 16 / 9
    }, params);
    return {
        url: Util.createImgUrl(imageUrl, settings),
        alt: resolvedAlt,
        srcSet: Util.createImageSrcSet(imageUrl, imageSizes, settings),
        sizes: Util.createImageSizes(imageSizes, imageUrl)
    };
}
function getVariantImages(variant, params, responsive = true) {
    const settings = swcHelpers.objectSpread({
        fit: 'fill',
        format: 'jpeg',
        width: imageSizes.MAX,
        aspectRatio: 16 / 9
    }, params);
    return getProductImages(variant, responsive, settings);
}
// Map placeholderImage to correct format
const placeholderImg = {
    url: placeholderImage.url
};
function getProductImages(variant, responsive, params) {
    const images = variant.images;
    if (!images || !images.length) {
        return [
            placeholderImg
        ];
    }
    const settings = swcHelpers.objectSpread({
        fit: 'fill',
        format: 'jpeg'
    }, params);
    return images.map((img)=>{
        const imageUrl = img.url;
        return responsive ? createResponsiveImage(imageUrl, img.altTag, settings) : {
            url: Util.createImgUrl(imageUrl, settings),
            alt: img.altTag
        };
    });
}

export { createResponsiveImage, getProductImages, getVariantImages, imageSizes };
//# sourceMappingURL=get-variant-images.js.map
